import { useState, useLayoutEffect, useCallback } from "react";

interface Query {
  xs?: Record<string, boolean>;
  sm?: Record<string, boolean>;
  md?: Record<string, boolean>;
  lg?: Record<string, boolean>;
  xl?: Record<string, boolean>;
  xxl?: Record<string, boolean>;
}

export const queryValue = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

const useWindowDimensions = () => {
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  });

  const updateSize = useCallback(() => {
    setSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    // eslint-disable-next-line
  }, [window]);

  useLayoutEffect(() => {
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
    // eslint-disable-next-line
  }, []);

  const getClassesNameByQuery = (query: Query) => {
    if (query.xxl && size.width >= queryValue.xxl) {
      return Object.entries(query.xxl)
        .flatMap(([key, value]) => (value ? [key] : []))
        .join(" ");
    }
    if (query.xl && size.width >= queryValue.xl) {
      return Object.entries(query.xl)
        .flatMap(([key, value]) => (value ? [key] : []))
        .join(" ");
    }
    if (query.lg && size.width >= queryValue.lg) {
      return Object.entries(query.lg)
        .flatMap(([key, value]) => (value ? [key] : []))
        .join(" ");
    }
    if (query.md && size.width >= queryValue.md) {
      return Object.entries(query.md)
        .flatMap(([key, value]) => (value ? [key] : []))
        .join(" ");
    }
    if (query.sm && size.width >= queryValue.sm) {
      return Object.entries(query.sm)
        .flatMap(([key, value]) => (value ? [key] : []))
        .join(" ");
    }
    if (query.xs) {
      return Object.entries(query.xs)
        .flatMap(([key, value]) => (value ? [key] : []))
        .join(" ");
    }
    return " ";
  };

  return { size, getClassesNameByQuery };
};

export default useWindowDimensions;
